import { useState } from "react";
import { toast } from "react-toastify";
import Modal from "../../../../components/lib/modal";
import CustomerService from "../../../../rest/customerService";
import ConfirmCloseView from "../confirmCloseView";
import EmployeeRegisterStepper from "./employeeRegisterStepper";

const EmployeeRegisterModal = ({ isOpen, setIsOpen }) => {
    const [hasData, setHasData] = useState(false);
    const [confirmClose, setConfirmClose] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const requestClose = () => {
        if (hasData) {
            setConfirmClose(true);
        } else {
            setIsOpen(false);
        }
    };

    const forceClose = () => {
        setConfirmClose(false);
        setIsOpen(false);
    };
    
    const handleFinish = async ({ employee }) => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const createdEmployee = await CustomerService.registerEmployee(employee);
            const credentials = [];

            if (createdEmployee.login && createdEmployee.password) {
                credentials.push({
                    id: createdEmployee.id,
                    login: createdEmployee.login,
                    password: createdEmployee.password
                });
            }

            // TODO: Envio de credenciais por email aqui se necessário

            toast.success("Cadastro efetuado com sucesso!");
            setIsOpen(false);
        } catch (err) {
            console.error("❌ Erro no cadastro:", err);
            toast.error("Erro ao finalizar cadastro.");
        } finally {
            setIsSubmitting(false);
        }
    };


    return (
        <Modal
            isOpen={isOpen}
            setIsOpen={requestClose}
            title="Efetuar Cadastro"
            hideFooter
        >
            <div className="relative">
                <EmployeeRegisterStepper
                    onDirty={() => setHasData(true)}
                    onCancel={requestClose}
                    onFinish={handleFinish}
                    isSubmitting={isSubmitting}
                />

                {confirmClose && (
                    <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/95 backdrop-blur-sm p-4 rounded-lg">
                        <ConfirmCloseView
                            onCancel={() => setConfirmClose(false)}
                            onConfirm={forceClose}
                        />
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default EmployeeRegisterModal;